export default "__VITE_ASSET__CvGnDvch__"